import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-div" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-one-third-desktop is-offset-one-third-desktop" }
const _hoisted_5 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "is-flex is-flex-direction-column is-justify-content-center"
}
const _hoisted_7 = {
  key: 1,
  class: "is-flex is-flex-direction-column is-align-content-center"
}
const _hoisted_8 = { class: "is-size-5 has-text-centered" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "control button_container" }
const _hoisted_11 = {
  key: 2,
  class: "is-flex is-flex-direction-column is-align-content-center"
}
const _hoisted_12 = { class: "mt-5 has-text-centered" }
const _hoisted_13 = { class: "is-size-3" }
const _hoisted_14 = { class: "is-size-5" }
const _hoisted_15 = { class: "control button_container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: "https://i.imgur.com/uA3fRLZ.png",
                class: "image",
                alt: "logo"
              })
            ], -1)),
            (_ctx.processing && !_ctx.hasError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('VetData.WaitForAuthentication')), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("progress", { class: "progress is-primary" }, null, -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mt-5 has-text-centered" }, [
                    _createElementVNode("span", { class: "fa fa-times has-text-danger fa-6x" })
                  ], -1)),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('VetData.CalendarAssociationProblem')), 1),
                  _createElementVNode("p", {
                    class: "has-text-grey has-text-centered",
                    innerHTML: _ctx.replaceSpecialCharacters(_ctx.$t('Customer.ContactSupport'))
                  }, null, 8, _hoisted_9),
                  _createElementVNode("p", _hoisted_10, [
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToVetDataMeth && _ctx.goToVetDataMeth(...args))),
                      class: "button is-light"
                    }, _toDisplayString(_ctx.$t('General.OK')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.processing && !_ctx.hasError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mt-5" }, [
                    _createElementVNode("span", { class: "fa fa-check has-text-success fa-6x" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('General.ThankYou')), 1),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('VetData.CalendarAssociationConfirmed')), 1),
                    _createElementVNode("p", _hoisted_15, [
                      _createElementVNode("a", {
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToVetDataMeth && _ctx.goToVetDataMeth(...args))),
                        class: "button is-light"
                      }, _toDisplayString(_ctx.$t('General.OK')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}